import React from 'react';

import GlobalStyles from '@mui/material/GlobalStyles';

const ROW_HEIGHT = 62;

const AgGridStyles = () => {
  return (
    <GlobalStyles
      styles={() => ({
        '.ag-theme-dokka': {
          '&': {
            '--ag-row-height': `${ROW_HEIGHT}px`,
          },

          '& .ag-row': {
            maxHeight: ROW_HEIGHT,
          },

          '& .ag-column-first': {
            borderRadius: '8px 0 0 8px',
            borderLeft: '1px solid var(--ag-border-color)',
          },

          '& .ag-column-last': {
            borderRadius: '0 8px 8px 0',
            borderRight: '1px solid var(--ag-border-color) !important',
          },
        },
      })}
    />
  );
};

export default AgGridStyles;
